import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RegisterForm from "./components/RegisterForm";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import QRScanner from "./admin/QRScanner";
import AdminRecords from "./admin/AdminRecords";
import UserLanding from "./UserLanding";
import UserProfile from "./components/UserProfile";
import ProtectedRoute from "./admin/ProtectedRoutes";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UserLanding />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/admin/qrscanner" element={<QRScanner />} />
        <Route path="/admin/records" element={<AdminRecords />} />
      </Routes>
    </Router>
  );
}

export default App;
